import React from 'react';
import { ArrowUpRight, Plane, Hotel, MapPin } from 'lucide-react';
import { useCountry, useCtaHandler } from '../context/CountryContext';
import FadeInSection from './FadeInSection';

export default function BaliPrize() {
  const { telegramUrl } = useCountry();
  const track = useCtaHandler();
  return (
    <section id="bali" className="relative py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Image */}
          <FadeInSection className="card-dark overflow-hidden">
            <div className="relative aspect-[4/5] md:aspect-[4/4.5]">
              <img
                loading="lazy"
                decoding="async"
                src="https://images.unsplash.com/photo-1573790387438-4da905039392?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80"
                alt="Nusa Penida, Bali"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(10,10,11,0.1) 0%, rgba(10,10,11,0.75) 100%)' }} />
              <div className="absolute top-4 left-4 flex items-center gap-2 nav-glass rounded-full px-3 py-1.5">
                <MapPin className="w-3.5 h-3.5 text-[#ff9b5a]" />
                <span className="text-white/90 text-[12px]">Bali, Indonesia</span>
              </div>
              <div className="absolute left-5 right-5 bottom-5">
                <div className="text-[11px] uppercase tracking-[0.18em] text-[#ff9b5a]">The Grand Prize</div>
                <div className="mt-1 font-display font-bold text-2xl text-white">3 Days. 2 Nights.</div>
                <div className="text-[#f2f2f2] text-sm">Luxury Resort Experience.</div>
              </div>
            </div>
          </FadeInSection>

          {/* Text */}
          <FadeInSection delay={0.15}>
            <h2 className="font-display font-extrabold text-white text-4xl md:text-[52px] leading-[1.05] tracking-tight">
              30 Silver Lots.
              <br />
              <span className="text-orange-gradient">Your ticket to Bali.</span>
            </h2>
            <p className="mt-5 text-[#f2f2f2] text-[15px] leading-relaxed">
              Once you cross the ultimate 30 Silver lot mark, you unlock our fully sponsored Bali vacation. Remember, this is <span className="text-white font-semibold">NOT</span> a lucky draw. Hit the target and you get the trip. Guaranteed. T&Cs apply.
            </p>

            <div className="mt-8 space-y-4">
              <div className="card-dark p-5 flex items-start gap-4">
                <div className="icon-badge shrink-0"><Plane className="w-5 h-5" /></div>
                <div>
                  <div className="text-white font-semibold uppercase tracking-wide">Free Return Flights</div>
                  <div className="text-[#f2f2f2] text-[13.5px] mt-1">Return flight tickets from your home country straight to Bali.</div>
                </div>
              </div>
              <div className="card-dark p-5 flex items-start gap-4">
                <div className="icon-badge shrink-0"><Hotel className="w-5 h-5" /></div>
                <div>
                  <div className="text-white font-semibold uppercase tracking-wide">Luxury Resort</div>
                  <div className="text-[#f2f2f2] text-[13.5px] mt-1">3 Days and 2 Nights stay at a premium luxury resort.</div>
                </div>
              </div>
            </div>

            <a href={telegramUrl} target="_blank" rel="noreferrer" onClick={() => track('bali-cta')} className="btn-orange inline-flex items-center gap-2 px-6 py-3.5 text-[14.5px] mt-8">
              Secure My Bali Trip <ArrowUpRight className="w-4 h-4" />
            </a>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
}
